function s(r) {
  if (!r || typeof r.then != "function")
    throw new Error("The provide function is not a promise");
  return r;
}
function d(r, n) {
  return (...i) => new Promise((o, t) => {
    r.id && clearTimeout(r.id), r.id = setTimeout(() => {
      try {
        const e = n(...i);
        o(e);
      } catch (e) {
        t(e);
      }
    }, r.delay);
  });
}
export {
  d as debounce,
  s as isPromise
};
